import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { MarketStatusResponse } from '../types/api';
import { AlertTriangle, Clock } from 'lucide-react';

export function MarketClosureTicker() {
  const [status, setStatus] = useState<MarketStatusResponse | null>(null);

  useEffect(() => {
    const loadStatus = async () => {
      try {
        const data = await api.getMarketStatus();
        setStatus(data);
      } catch (error) {
        console.error('Error loading market status:', error);
      }
    };

    loadStatus();
    const interval = setInterval(loadStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!status || (!status.is_market_closed && !status.is_early_close)) {
    return null;
  }

  const isClosedCompletely = status.is_market_closed;
  const bgColor = isClosedCompletely ? 'bg-red-600' : 'bg-amber-500';
  const Icon = isClosedCompletely ? AlertTriangle : Clock;

  return (
    <div className={`${bgColor} text-white overflow-hidden`}>
      <div className="ticker-wrapper">
        <div className="ticker-content flex items-center gap-3 py-2 px-4 whitespace-nowrap animate-ticker">
          <Icon className="w-4 h-4 flex-shrink-0" />
          <span className="font-semibold text-sm">{status.message}</span>
          <span className="mx-8 opacity-50">|</span>
          <Icon className="w-4 h-4 flex-shrink-0" />
          <span className="font-semibold text-sm">{status.message}</span>
          <span className="mx-8 opacity-50">|</span>
          <Icon className="w-4 h-4 flex-shrink-0" />
          <span className="font-semibold text-sm">{status.message}</span>
          <span className="mx-8 opacity-50">|</span>
          <Icon className="w-4 h-4 flex-shrink-0" />
          <span className="font-semibold text-sm">{status.message}</span>
        </div>
      </div>
      <style>{`
        .ticker-wrapper {
          overflow: hidden;
          position: relative;
        }
        .animate-ticker {
          animation: ticker 20s linear infinite;
        }
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
